import { EnvironmentProviders, Provider } from "@angular/core";
import { AUTH_CLIENT, AUTH_EVENTS, AUTH_ROUTE_GUARD } from "@commonInterfaces/iAuthAccess";
import { NoAuthClient, NoAuthEvents, NoAuthRouteGuard } from "@commonServices/no-auth.adapter";
import { interceptorProvider } from "./msalb2c.interceptor.provider";

// Provider für Besucher ohne Anmeldung - und damit für jeden Crawler. Kein Verweis auf
// @azure/msal-*, weder direkt noch über den Adapter.
//
// Der Interceptor bleibt bereitgestellt: er steigt bei `!isLoggedIn()` sofort aus, und
// isLoggedIn() liefert über NoAuthClient.getAllAccounts() eine leere Liste. So bleibt die
// HTTP-Kette in beiden Zweigen identisch aufgebaut.
export const noAuthProviders = (): (Provider | EnvironmentProviders)[] => [
	{ provide: AUTH_CLIENT, useFactory: () => new NoAuthClient() },
	{ provide: AUTH_EVENTS, useFactory: () => new NoAuthEvents() },
	{ provide: AUTH_ROUTE_GUARD, useFactory: () => new NoAuthRouteGuard() },
	interceptorProvider,
];
